import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Mail, Lock, ArrowRight } from 'lucide-react';
import { API } from './portalShared';

export default function BrandLogin({ onLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault(); setError(''); setLoading(true);
    try {
      const { data } = await axios.post(`${API}/portal/auth/login`, { email, password });
      localStorage.setItem('propost_brand_token', data.access_token);
      onLogin(data.brand);
    } catch (e) { setError(e.response?.data?.detail || 'Login failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-[#090E33] flex items-center justify-center px-4 py-10" data-testid="brand-login">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="https://customer-assets.emergentagent.com/job_campaign-board/artifacts/pflz8b2v_freddy-logo-symbol.png" alt="" className="h-14 w-14 mx-auto mb-4" />
          <h1 className="font-display text-3xl font-bold"><span className="text-[#FF4343]">Freddy</span>Leads</h1>
          <p className="text-[#9CA3AF] text-sm mt-1">Brand Portal</p>
        </div>

        <div className="mb-4 bg-white/[0.03] border border-white/10 px-4 py-3 text-center" data-testid="brand-signup-closed">
          <p className="text-[10px] uppercase tracking-[0.25em] font-mono text-[#FF4343] mb-1">★ Brand sign-up by invite ★</p>
          <p className="text-xs text-[#9CA3AF] leading-relaxed">
            New here? Book a 20-min walkthrough with Jon and we&apos;ll spin up your portal for you.
          </p>
          <a
            href="https://meetings.hubspot.com/jon980"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="brand-portal-book-walkthrough"
            className="inline-block mt-2 text-[11px] font-semibold uppercase tracking-wider border-b border-[#FF4343] text-[#FF4343] hover:text-white hover:border-white pb-0.5 transition-colors"
          >
            Book my walkthrough →
          </a>
        </div>

        <div className="glass p-6 sm:p-8">
          {error && <div className="mb-4 p-3 bg-red-500/10 border border-red-500/20 text-red-400 text-sm">{error}</div>}
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="relative"><Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
              <input type="email" placeholder="Portal email" value={email} onChange={e => setEmail(e.target.value)} required data-testid="brand-email"
                className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 text-white placeholder-[#6B7280] text-sm focus:outline-none focus:border-[#FF4343]" /></div>
            <div className="relative"><Lock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#6B7280]" />
              <input type="password" placeholder="Password" value={password} onChange={e => setPassword(e.target.value)} required data-testid="brand-password"
                className="w-full pl-10 pr-4 py-3 bg-white/5 border border-white/10 text-white placeholder-[#6B7280] text-sm focus:outline-none focus:border-[#FF4343]" /></div>
            <button type="submit" disabled={loading} data-testid="brand-login-btn"
              className="w-full flex items-center justify-center gap-2 border-2 border-[#FF4343] bg-[#FF4343] text-[#090E33] py-3 text-sm font-semibold transition-all disabled:opacity-50">
              {loading ? 'Signing in...' : 'Sign In'} <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>

        <div className="text-center mt-6">
          <Link to="/login" data-testid="exec-login-link" className="text-xs text-[#6B7280] hover:text-[#FF4343] transition-colors">
            Are you an executive? Log in here &rarr;
          </Link>
          <div className="flex justify-center gap-3 mt-4">
            <Link to="/terms" className="text-[10px] text-[#6B7280] hover:text-white transition-colors">Terms</Link>
            <span className="text-[10px] text-[#6B7280]">&middot;</span>
            <Link to="/privacy" className="text-[10px] text-[#6B7280] hover:text-white transition-colors">Privacy</Link>
          </div>
        </div>
      </div>
    </div>
  );
}
